<template>
  <a-form-item
    v-if="field.type !== 'divider' && (field?.is_search_show !== false || field_render_show)"
    :extra="field.extra"
    :label="
      is_show_label ? (field.label_i18n == undefined ? field.label : t(field.label_i18n)) : null
    "
    :name="field.name"
    v-bind="validateInfos ? validateInfos[field.name] : null"
  >
    <div
      v-if="field.type === 'kong'"
      style="height: 62px; width: 100%"
    ></div>
    <!--    展示内容-->
    <div v-if="field.type === 'tag'">
      <a-tag
        :color="field.color ? field.color(field, model) : 'green'"
        :style="field.style"
        v-if="(field.content && field.content(field, model)) || model"
        @click="field.cb ? field.cb(field, model) : ''"
      >
        <span v-if="field.content">
          {{ field.content(field, model) }}
        </span>
        <span v-else>{{ model }}</span>
      </a-tag>
    </div>
    <!--    表单占位组件-->
    <!--    默认 【表单空位 高62px; 名称空位 高30px;】 如遇个别特殊表单，根据实际情况自行调节 高度-->
    <!--    height 属性必填-->
    <div
      v-if="field.type === 'kong_title'"
      :style="'height: ' + field.height + 'px'"
    ></div>
    <div
      v-if="field.type === 'title'"
      style="height: 30px; position: relative"
    >
      <span
        style="
          position: absolute;
          bottom: 0;
          padding: 0;
          margin: 0;
          font-weight: bolder;
          font-size: 17px;
        "
      >
        {{ field.name }}
      </span>
    </div>
    <a-rate
      v-if="field.type === 'rate'"
      v-model:value="model"
      :disabled="field.disabled"
      allow-half
    />
    <a-input
      v-if="field.type === 'input'"
      v-model:value="model"
      :addon-after="field.addonAfter"
      :addon-before="field.addonBefore"
      :allow-clear="field.allowClear == undefined ? true : field.allowClear"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :maxlength="field.maxlength"
      :placeholder="field.placeholder ? field.placeholder : $t('请输入') + field.label"
      :type="field.type ? field.type : 'input'"
      size="small"
    />
    <a-input
      v-if="field.type === 'volume'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :maxlength="field.maxlength"
      :placeholder="field.placeholder ? field.placeholder : $t('请输入') + field.label"
      addon-after="L"
      size="small"
      type="number"
    />
    <a-input
      v-if="field.type === 'weight'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :maxlength="field.maxlength"
      :placeholder="field.placeholder ? field.placeholder : $t('请输入') + field.label"
      addon-after="Kg"
      size="small"
      type="number"
    />
    <attribute-table
      v-if="field.type === 'attributetable'"
      v-model:value="model"
      :field="field"
      :formModel="formModel"
      :init_model="field.init_model"
      size="small"
    />
    <attribute-nom-table
      v-if="field.type === 'attributenomtable'"
      size="small"
      v-model:value="model"
      :field="field"
      :formModel="formModel"
      :init_model="field.init_model"
    />

    <a-textarea
      v-if="field.type === 'textarea'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :autoSize="{
        minRows: field.minRows ? field.minRows : 5,
        maxRows: field.maxRows ? field.maxRows : null,
      }"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :disabled="field.disabled"
      :placeholder="field.placeholder ? field.placeholder : $t('请输入') + field.label"
    />
    <json-str
      v-if="field.type === 'jsonstr'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :disabled="field.disabled"
      :placeholder="field.placeholder ? field.placeholder : $t('请输入') + field.label"
    />
    <json-obj
      v-if="field.type === 'jsonobj'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :disabled="field.disabled"
      :placeholder="field.placeholder ? field.placeholder : $t('请输入') + field.label"
    />
    <a-input-number
      v-if="field.type === 'number'"
      v-model:value="model"
      :addon-after="field.addonAfter"
      :addon-before="field.addonBefore"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :formatter="field.formatter"
      :max="field.max"
      :min="field.min"
      :placeholder="field.placeholder ? field.placeholder : $t('请输入') + field.label"
      :precision="field.precision"
      :step="field.step"
      size="small"
      style="width: 100%"
    />
    <a-input-password
      v-if="field.type === 'password'"
      v-model:value="model"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :formatter="field.formatter"
      :max="field.max"
      :min="field.min"
      :placeholder="field.placeholder ? field.placeholder : $t('请输入') + field.label"
      :precision="field.precision"
      :step="field.step"
      size="small"
      style="width: 100%"
    />
    <template v-if="field.type === 'select'">
      <a-select
        v-if="field.mode === 'default'"
        v-model:value="model"
        :allow-clear="field.allowClear"
        :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
        :default-value="field.defaultValue"
        :disabled="field.disabled"
        :dropdownMatchSelectWidth="false"
        :maxTagCount="field.maxTagCount ? field.maxTagCount : 'responsive'"
        :placeholder="field.placeholder ? field.placeholder : $t('请选择') + field.label"
        :show-search="!!field.show_search"
        size="small"
        style="min-width: 150px"
      >
        <a-select-option
          v-for="option in options"
          :key="option[field.valueKey ? field.valueKey : 'value']"
          :value="option[field.valueKey ? field.valueKey : 'value']"
        >
          {{ option[field.labelKey ? field.labelKey : 'label'] }}
        </a-select-option>
      </a-select>
      <a-select
        v-else
        v-model:value="model"
        :allow-clear="field.allowClear"
        :default-value="field.defaultValue"
        :disabled="field.disabled"
        :dropdownMatchSelectWidth="false"
        :maxTagCount="field.maxTagCount ? field.maxTagCount : 'responsive'"
        :mode="field.mode"
        :placeholder="field.placeholder ? field.placeholder : $t('请选择') + field.label"
        :show-search="!!field.show_search"
        size="small"
        style="min-width: 150px"
      >
        <a-select-option
          v-for="(option, index) in options"
          :key="index"
          :value="option[field.valueKey ? field.valueKey : 'value']"
        >
          {{ option[field.labelKey ? field.labelKey : 'label'] }}
        </a-select-option>
      </a-select>
    </template>
    <template v-if="field.type === 'groupselect'">
      <a-select
        v-if="field.mode === 'default'"
        v-model:value="model"
        :allow-clear="field.allowClear"
        :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
        :default-value="field.defaultValue"
        :disabled="field.disabled"
        :dropdownMatchSelectWidth="false"
        :getPopupContainer="field.getPopupContainer == undefined ? null : field.getPopupContainer"
        :labelInValue="field.labelInValue === true"
        :maxTagCount="field.maxTagCount ? field.maxTagCount : 'responsive'"
        :options="options"
        :placeholder="field.placeholder ? field.placeholder : $t('请选择') + field.label"
        :show-search="!!field.show_search"
        size="small"
        style="min-width: 150px"
      ></a-select>
      <a-select
        v-else
        v-model:value="model"
        :allow-clear="field.allowClear"
        :default-value="field.defaultValue"
        :disabled="field.disabled"
        :dropdownMatchSelectWidth="false"
        :getPopupContainer="field.getPopupContainer == undefined ? null : field.getPopupContainer"
        :labelInValue="field.labelInValue === true"
        :maxTagCount="field.maxTagCount ? field.maxTagCount : 'responsive'"
        :mode="field.mode"
        :options="options"
        :placeholder="field.placeholder ? field.placeholder : $t('请选择') + field.label"
        :show-search="!!field.show_search"
        size="small"
        style="min-width: 150px"
      ></a-select>
    </template>

    <remote-select-pro
      v-if="field.type === 'remoteselectpro'"
      v-model:label="labelModel"
      v-model:value="model"
      :field="field"
      :formModel="formModel"
      :outModel="outModel"
      :get-data="field.getData"
      :init_model="field.init_model"
      :init_watch="field.init_watch"
      :label-key="field.labelKey"
      :label-key-type="field.labelKeyType"
      :label-key-list="field.labelKeyList"
      :label-space="field.labelSpace"
      :search_config="field.search_config"
      :value-key="field.valueKey"
      :is_input="field.is_input"
      :placeholder="
        field.placeholder_i18n == undefined
          ? field.placeholder
            ? field.placeholder
            : t('请选择') + field.label
          : t(field.placeholder_i18n)
      "
    />
    <a-cascader
      v-if="field.type === 'cascader'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :changeOnSelect="field.changeOnSelect"
      :options="field.getOptionsData ? field.getOptionsData(options, model) : options"
      :placeholder="field.placeholder ? field.placeholder : $t('请选择') + field.label"
      size="small"
    />
    <remote-cascader
      v-if="field.type === 'remotecascader'"
      v-model:value="model"
      v-model:label="labelModel"
      :field="field"
      :formModel="formModel"
      :get-data="field.getData"
      :init_model="field.init_model"
      :label-key="field.labelKey"
      :label-key-list="field.labelKeyList"
      :label-space="field.labelSpace"
      :search_config="field.search_config"
      :value-key="field.valueKey"
    />

    <a-month-picker
      v-if="field.type === 'monthpicker'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :format="field.format"
      :placeholder="field.placeholder ? field.placeholder : $t('请选择') + field.label"
      :show-time="field.showTime"
      :value-format="field.valueFormat"
      size="small"
      style="width: 100%"
    />
    <a-date-picker
      v-if="field.type === 'datepicker'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :format="field.format"
      :placeholder="field.placeholder ? field.placeholder : $t('请选择') + field.label"
      :show-time="field.showTime"
      :value-format="field.valueFormat"
      :picker="field.picker ? field.picker : 'date'"
      :disabled-date="field.disabledDate"
      size="small"
      style="width: 100%"
    />

    <a-range-picker
      v-if="field.type === 'rangepicker'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :format="field.format"
      :placeholder="field.placeholder ? field.placeholder : [$t('开始时间'), $t('结束时间')]"
      :show-time="field.showTime"
      :value-format="field.valueFormat"
      :picker="field.picker ? field.picker : 'date'"
      :disabled-date="field.disabledDate"
      size="small"
      style="width: 100%"
    />

    <a-time-picker
      v-if="field.type === 'timepicker'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :format="field.format ? field.format : 'HH:mm'"
      :placeholder="field.placeholder ? field.placeholder : $t('请选择') + field.label"
      :value-format="field.valueFormat ? field.valueFormat : 'HH:mm'"
      size="small"
      style="width: 100%"
    />
    <a-radio-group
      v-if="field.type === 'radio'"
      v-model:value="model"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      size="small"
    >
      <a-radio
        v-for="option in options"
        :key="option[field.valueKey ? field.valueKey : 'value']"
        :disabled="option.disabled"
        :value="option[field.valueKey ? field.valueKey : 'value']"
      >
        {{ option[field.labelKey ? field.labelKey : 'label'] }}
      </a-radio>
    </a-radio-group>

    <a-checkbox-group
      v-if="field.type === 'checkbox'"
      v-model:value="model"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      size="small"
    >
      <a-checkbox
        v-for="option in options"
        :key="option[field.valueKey ? field.valueKey : 'value']"
        :disabled="option.disabled"
        :value="option[field.valueKey ? field.valueKey : 'value']"
      >
        {{ option[field.labelKey ? field.labelKey : 'label'] }}
      </a-checkbox>
    </a-checkbox-group>

    <a-tree-select
      v-if="field.type === 'treeselect'"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :dropdownMatchSelectWidth="false"
      :placeholder="field.placeholder ? field.placeholder : $t('请选择') + field.label"
      :tree-checkable="field.multiple"
      :tree-data="options"
      :tree-label-prop="field.labelKey"
      :tree-node-filter-prop="field.valueKey"
      size="small"
    />
    <remote-filter-select
      v-if="field.type === 'remotefilterselect'"
      v-model:label="labelModel"
      v-model:value="model"
      :field="field"
      :formModel="formModel"
      :get-data="field.getData"
      :init_model="field.init_model"
      :label-key="field.labelKey"
      :label-key-list="field.labelKeyList"
      :label-space="field.labelSpace"
      :search_config="field.search_config"
      :value-key="field.valueKey"
    />
    <remote-select
      v-if="field.type === 'remoteselect'"
      v-model:label="labelModel"
      v-model:value="model"
      :field="field"
      :formModel="formModel"
      :get-data="field.getData"
      :init_model="field.init_model"
      :label-key="field.labelKey"
      :label-key-list="field.labelKeyList"
      :label-space="field.labelSpace"
      :search_config="field.search_config"
      :value-key="field.valueKey"
    />
    <remote-tree-select
      v-if="field.type === 'remotetreeselect'"
      v-model:label="labelModel"
      v-model:value="model"
      :allow-clear="field.allowClear"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      :field="field"
      :formModel="formModel"
      :get-data="field.getData"
      :label-key="field.labelKey"
      :search_config="field.search_config"
      :value-key="field.valueKey"
    />
    <remote-modal
      v-if="field.type === 'remotemodal'"
      v-model:label="labelModel"
      v-model:value="model"
      :columns="field.columns"
      :field="field"
      :field_status="field.field_status"
      :get-data="field.getData"
      :init_model="field.init_model"
      :modalType="field.modalType"
      :search_config="field.search_config"
      :watch="field.watch"
    />
    <remote-table
      v-if="field.type === 'remotetable'"
      v-model:value="model"
      :columns="field.columns"
      :formModel="formModel"
      :field="field"
      :field_status="field.field_status"
      :get-data="field.getData"
      :init_model="field.init_model"
      :modalType="field.modalType"
      :search_config="field.search_config"
      :watch="field.watch"
    />
    <remote-table-2
      v-if="field.type === 'remotetable2'"
      v-model:value="model"
      :columns="field.columns"
      :formModel="formModel"
      :field="field"
      :field_status="field.field_status"
      :get-data="field.getData"
      :init_model="field.init_model"
      :modalType="field.modalType"
      :search_config="field.search_config"
      :watch="field.watch"
    />
    <remote-text
      v-if="field.type === 'remotetext'"
      v-model:value="model"
      :columns="field.columns"
      :formModel="formModel"
      :field="field"
      :get-data="field.getData"
      :init_model="field.init_model"
      :modalType="field.modalType"
      :search_config="field.search_config"
      :watch="field.watch"
    />
    <a-radio-group
      v-if="field.type === 'radio-color'"
      v-model:value="model"
      :default-value="field.defaultValue"
      :disabled="field.disabled"
      size="small"
    >
      <a-radio
        v-for="option in options"
        :key="option[field.valueKey ? field.valueKey : 'value']"
        :disabled="option.disabled"
        :value="option[field.valueKey ? field.valueKey : 'value']"
      >
        <div
          :style="{
            width: '20px',
            height: '20px',
            backgroundColor: option[field.valueKey ? field.valueKey : 'value'],
          }"
        ></div>
      </a-radio>
    </a-radio-group>
    <div v-if="field.type === 'button'">
      <a-button :type="field.btn_type" :size="field.size" @click="field.cb(formModel)">{{ field.btn_text }}</a-button>
    </div>
  </a-form-item>

  <a-divider
    v-if="field.type === 'divider'"
    :orientation="field.orientation"
  >
    {{ field.label }}
  </a-divider>
</template>
<script lang="ts">
import RemoteSelect from 'liyu-pc-base/components/FormRender/RemoteSelect/RemoteSelect.vue';
import RemoteCascader from 'liyu-pc-base/components/FormRender/RemoteCascader/RemoteCascader.vue';
import RemoteModal from 'liyu-pc-base/components/FormRender/RemoteModal/RemoteModal.vue';
import RemoteTreeSelect from 'liyu-pc-base/components/FormRender/RemoteTreeSelect/RemoteTreeSelect.vue';
import RemoteTable from 'liyu-pc-base/components/FormRender/RemoteTable/RemoteTable.vue';
import { defineComponent } from 'vue';
import RemoteFilterSelect from 'liyu-pc-base/components/FormRender/RemoteFilterSelect/RemoteFilterSelect.vue';
import AttributeNomTable from 'liyu-pc-base/components/FormRender/AttributeNomTable/index.vue';
import AttributeTable from 'liyu-pc-base/components/FormRender/AttributeTable/index.vue';
import JsonStr from 'liyu-pc-base/components/FormRender/JsonStr/index.vue';
import JsonObj from 'liyu-pc-base/components/FormRender/JsonObj/index.vue';
import RemoteText from 'liyu-pc-base/components/FormRender/RemoteText/RemoteText.vue';
import RemoteTable2 from 'liyu-pc-base/components/FormRender/RemoteTable2/RemoteTable2.vue';
import RemoteSelectPro from 'liyu-pc-base/components/FormRender/RemoteSelectPro/RemoteSelectPro.vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'FieldRender',
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      required: true,
    },
    label: {
      required: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    validateInfos: {
      type: Object,
      default: () => {},
    },
    formModel: {
      type: Object,
      default: () => {},
    },
    outModel: {
      type: Object,
      default: () => {},
    },
    field_render_show: {
      type: Boolean,
      default: true,
    },
    is_show_label: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
  data() {
    const rangeDate = (v: any) => {
      if (typeof v == 'string' && v.indexOf(',') >= 0) {
        return v.split(',');
      }
      return v;
    };
    return {
      rangeDate,
      model: this.field.type == 'rangepicker' ? rangeDate(this.value) : this.value,
      labelModel: this.label,
    };
  },
  watch: {
    model: {
      handler(newValue) {
        this.$emit('update:value', newValue);
      },
    },
    value: {
      handler(newValue) {
        if (this.field.type === 'input' && newValue) {
          this.model = newValue.toString().replace(/(^\s*)|(\s*$)/g, '');
        } else {
          this.model = newValue;
        }
      },
    },
    labelModel: {
      handler(newValue) {
        this.$emit('update:label', newValue);
      },
    },
    label: {
      handler(newValue) {
        this.labelModel = newValue;
      },
    },
  },
  created() {},
  components: {
    RemoteSelectPro,
    AttributeTable,
    AttributeNomTable,
    RemoteFilterSelect,
    RemoteModal,
    RemoteSelect,
    RemoteCascader,
    RemoteTreeSelect,
    RemoteTable,
    JsonStr,
    JsonObj,
    RemoteText,
    RemoteTable2,
  },
});
</script>

<style scoped>
.ant-calendar-picker {
  width: 100% !important;
}
</style>
